// firestore-datenbank service
// stellt die verbindung zur firebase firestore datenbank her
// verbindet automatisch mit dem emulator im entwicklungsmodus
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getApp, getApps } from 'firebase/app'
import { USE_EMULATOR, EMULATOR_PORTS } from '../config/firebase'

// variable zum speichern der firestore-datenbankinstanz
let db = null

// funktion zum abrufen der firestore-datenbankinstanz
// verbindet automatisch mit dem emulator im entwicklungsmodus
export function getDb() {
  // wenn noch keine datenbankinstanz existiert, erstelle eine neue
  if (!db) {
    // prüfe ob bereits eine firebase-app initialisiert wurde
    const app = getApps().length > 0 ? getApp() : null
    if (!app) {
      throw new Error('Firebase app not initialized')
    }
    // hole die firestore-instanz von der firebase-app
    db = getFirestore(app)
    
    // verbinde mit firestore emulator wenn konfiguriert
    if (USE_EMULATOR) {
      try {
        // prüfe ob bereits verbunden (verhindert fehler bei hot reload)
        const isAlreadyConnected = db._delegate?._settings?.host?.includes('localhost') ||
                                    db._delegate?._settings?.host?.includes('127.0.0.1')
        
        // wenn noch nicht verbunden, verbinde mit emulator
        if (!isAlreadyConnected) {
          connectFirestoreEmulator(db, 'localhost', EMULATOR_PORTS.firestore)
          console.log(`✅ Verbunden mit Firebase Firestore Emulator (localhost:${EMULATOR_PORTS.firestore})`)
        }
      } catch (error) {
        // wenn emulator nicht verfügbar, verwende cloud (nur warnung, kein fehler)
        console.warn('⚠️ Firestore Emulator nicht verfügbar, verwende Firebase Cloud:', error.message)
      }
    }
  }
  // gib die datenbankinstanz zurück
  return db
}
